import React, { useCallback, useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button, Skeleton } from "antd";
import PageContainer from "../../components/PageContainer";
import { ReactComponent as EmptyIcon } from "../../images/empty.svg";
import SearchArchive from "./components/SearchArchive";
import SessionItem from "./components/SessionItem";
import useInfiniteScroll from "../../hooks/useInfiniteScroll";
import { getSessionsServiceVersion2 as getSessionsService } from "./archive.api";
import { Messages } from "../../components/Messages";
import FilterArchive from "./components/filterArchive/FilterArchive";
import { PlusOutlined } from "@ant-design/icons";
import { findLawyerService } from "../consulting/consulting.api";

const Archive = () => {
  const { search } = useLocation();
  const containerRef = useRef();
  const [, setIsFetching] = useInfiniteScroll(moreArchivesList, containerRef);
  const [loading, setLoading] = useState(false);
  const [showSearchResult, setShowSearchResult] = useState(false);
  const [StatusFilters, setStatusFilters] = useState();
  const [pageNumber, setPageNumber] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [list, setList] = useState([]);
  const history = useHistory();
  const [, setMeta] = useState([]);

  useEffect(() => {
    try {
      const startSession = JSON.parse(
        atob(localStorage.getItem("startSession"))
      );
      if (startSession && history) {
        findLawyerService(startSession.id)
          .then((res) => {
            history.push(
              `/consultation/${startSession.type}/${res.data.sessionId}`
            );
          })
          .catch(() => {})
          .finally(() => {
            localStorage.removeItem("startSession");
          });
      }
    } catch {}
  }, [history]);

  useEffect(() => {
    return () => {
      const dismissLock = sessionStorage.getItem("dismissLock");
      if (!(dismissLock !== null && JSON.parse(dismissLock) === true)) {
        if (history.action === "POP") {
          history.replace("/home");
        }
      }
    };
  }, [history]);

  useEffect(() => {
    setPageNumber(0);
    const dismissLock = sessionStorage.getItem("dismissLock");
    !(dismissLock !== null && JSON.parse(dismissLock) === true) && setList([]);
  }, [StatusFilters]);

  useEffect(() => {
    if (pageNumber === 0 && StatusFilters) {
      fetchArchivesList();
    }
    // eslint-disable-next-line
  }, [pageNumber, StatusFilters]);

  useEffect(() => {
    setPageNumber(0);
    setList([]);
  }, [search]);

  // eslint-disable-next-line
  function moreArchivesList() {
    if (showLoadMore) {
      setLoading(true);

      const searchParams = new URLSearchParams(search);
      getSessionsService({
        pageNumber: pageNumber,
        pageSize: 20,
        ...StatusFilters,
        ...Object.fromEntries(searchParams),
      })
        .then((r) => {
          const { content, ...metaData } = r.data;
          setList([...list, ...content]);

          if (r.data && r.data.last === true) {
            setShowLoadMore(false);
          } else {
            setShowLoadMore(true);
          }
          setPageNumber(pageNumber + 1);
          setMeta(metaData);
        })
        .catch((e) => {
          setShowLoadMore(false);
          setIsFetching(false);
        })
        .finally(() => {
          setLoading(false);
          setIsFetching(false);
        });
    }
  }

  function resetArchiveList() {
    setPageNumber(0);
    setList([]);
    window.scrollTo(0, 0);
  }

  function fetchArchivesList() {
    setLoading(true);
    const searchParams = new URLSearchParams(search);
    getSessionsService({
      pageNumber: pageNumber,
      pageSize: 20,
      ...StatusFilters,
      ...Object.fromEntries(searchParams),
    })
      .then((r) => {
        const { content, ...metaData } = r.data;

        if (pageNumber === 0) {
          setList(content);
        } else if (content) {
          setList([...list, ...content]);
        }

        if (r.data && r.data.last === true) {
          setShowLoadMore(false);
        } else {
          setShowLoadMore(true);
        }

        setPageNumber(pageNumber + 1);
        setMeta(metaData);
      })
      .catch((e) => {})
      .finally(() => {
        setLoading(false);
        setIsFetching(false);
      });
  }

  const checkForNewMessages = useCallback(() => {
    const searchParams = new URLSearchParams(search);
    getSessionsService({
      pageNumber: 0,
      pageSize: 20,
      ...StatusFilters,
      ...Object.fromEntries(searchParams),
    })
      .then((r) => {
        const { content, ...metaData } = r.data;

        setList((pre) => {
          pre.splice(0, 20, ...content);
          return pre;
        });

        setMeta(metaData);
      })
      .catch((e) => {});
  }, [StatusFilters, search]);

  useEffect(() => {
    window.intervalTimerId = setInterval(function () {
      checkForNewMessages();
    }, 15000);
    return () => {
      if (window.intervalTimerId) {
        clearInterval(window.intervalTimerId);
      }
    };
  }, [checkForNewMessages]);

  // Todo: fix
  useEffect(() => {
    const header = document.getElementById("site-header");
    header.style.height = "215px";
    header.style.background = "#FFF";
  }, []);

  return (
    <PageContainer
      classNames="archive"
      headerProps={{
        right: <Messages />,
        content: "لیست مشاوره‌ها",
        className: "home-header-holder transactions-header-holder",
        children: (
          <div style={{ marginTop: 40 }}>
            <SearchArchive
              showSearchResult={showSearchResult}
              setShowSearchResult={setShowSearchResult}
              inputName="keyword"
            />
          </div>
        ),
        tall: true,
      }}
    >
      <div
        className="archive-title center-flex"
        onClick={() => setShowSearchResult(false)}
      >
        {/* <div className="title">لیست مشاوره ها</div> */}
        <div>
          <Button
            onClick={() => history.push("/consulting")}
            shape="round"
            style={{
              marginRight: 5,
            }}
            icon={<PlusOutlined />}
          >
            درخواست جدید
          </Button>
        </div>
        <div>
          <FilterArchive
            filters={StatusFilters}
            setfilters={setStatusFilters}
          />
        </div>
      </div>
      <div className="archives-wrapper">
        {!loading && list.length === 0 && (
          <div className="center-flex empty">
            <EmptyIcon className="mb-20" />
            اطلاعاتی وجود ندارد، برای شروع یک مشاوره را آغاز کنید
          </div>
        )}
        {list &&
          list.length > 0 &&
          list.map((i, index) => {
            return (
              <SessionItem
                list={list}
                item={i}
                index={index}
                resetArchiveList={resetArchiveList}
                key={`session-${index}`}
                {...i}
              />
            );
          })}

        {loading && showLoadMore && list.length > 0 && (
          <div className="archive-log mt-3 mb-20">
            <Skeleton
              active={true}
              avatar={{ shape: "circle" }}
              title={{ width: "50%" }}
              paragraph={false}
            />
          </div>
        )}

        {loading && (
          <>
            {[...Array(5).keys()].map((item, index) => (
              <div
                key={item}
                className={`archive-log ${index !== 0 && "mt-3"}`}
              >
                <Skeleton
                  active={true}
                  avatar={{ shape: "circle" }}
                  title={{ width: "50%" }}
                  paragraph={false}
                />
              </div>
            ))}
          </>
        )}
      </div>
    </PageContainer>
  );
};

export default Archive;
